module.exports = __webpack_public_path__ + "94f224949ab8dcfef458fb3bca5d5737.ttf";